import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
// import { CalendarFillIcon } from "@/src/Asset";
import { formatDate } from '@/utils/formatDate';

const FeaturedBlog = ({ featuredBlogs }: any) => {
  return (
    <section className="w-full">
      <h2 className="font-montserrat text-lg font-semibold text-primary underline underline-offset-2 lg:text-2xl">
        Featured Post
      </h2>

      <div className="hide-scrollbar my-5 flex justify-items-stretch gap-5 overflow-x-auto sm:grid sm:grid-cols-2 sm:overflow-visible md:grid-cols-2 xl:grid-cols-4">
        {featuredBlogs?.slice(0, 7)?.map((blog: any) => {
          const category = blog?.categories?.[0]?.category_name?.slice(0, 15) ?? null;

          return (
            <div key={blog?.id} className={`min-w-80 rounded-xl border shadow-lg sm:min-w-fit`}>
              <div className="!relative z-10">
                <Image
                  src={blog?.featured_image?.url ?? ''}
                  width={400}
                  height={260}
                  alt={blog?.blog_title ?? 'default blog'}
                  className={`h-44 w-full rounded-xl border object-fill md:h-52`}
                />
                {category && <div className="text-sm capitalize text-white">{category}</div>}
              </div>
              <div className="mt-3">
                <div className="flex items-center gap-x-1 px-2 text-xs">
                  {' '}
                  {/* <CalendarFillIcon /> */}
                  <p> {formatDate(blog?.updatedAt)}</p>
                </div>
                <Link
                  href={`/blogs/${blog?.blog_url}`}
                  className={`my-4 line-clamp-2 px-3 font-inter text-sm text-tertiary`}
                >
                  {blog?.blog_title}
                </Link>
                {/* <p className="text-sm line-clamp-3">{blog?.description}</p> */}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FeaturedBlog;
